import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation deleteAppointmentMenuProduct($id: ID!) {
    deleteAppointmentMenuProduct(id: $id)
  }
`);

export default function useDeleteService() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetServiceDetail'],
  });
}
